import styled from "styled-components";
import { typeStyle as getTypeStyle, visuallyHidden } from "@m/alchemy-theme";
import { cellPadding } from "../constants";
export const Caption = styled.caption `
  ${getTypeStyle("subHeaderM")};
  padding: ${cellPadding};
  text-align: left;

  ${({ isVisuallyHidden }) => isVisuallyHidden && visuallyHidden()}
`;
